import {getCategorySchemeUrl, getCodelistUrl, getConceptSchemeUrl, getDataflowUrl, getMetadataflowUrl} from "../../../constants/urls";
import {
  getArtefactTripletFromUrn,
  SDMX_JSON_CATEGORY_SCHEME_URN_NAMESPACE,
  SDMX_JSON_CODELIST_URN_NAMESPACE,
  SDMX_JSON_CONCEPT_SCEHME_URN_NAMESPACE,
  SDMX_JSON_DATAFLOW_URN_NAMESPACE,
  SDMX_JSON_METADATAFLOW_URN_NAMESPACE
} from "../../../utils/sdmxJson";

export const REPORT_DETAILS_WIZARD_STEP_FIRST = 0;
export const REPORT_DETAILS_WIZARD_STEP_SECOND = 1;

export const ARTEFACT_TYPES = [
  {
    type: "codelist",
    url: getCodelistUrl(),
    urnNamespace: SDMX_JSON_CODELIST_URN_NAMESPACE
  },
  {
    type: "categoryscheme",
    url: getCategorySchemeUrl(),
    urnNamespace: SDMX_JSON_CATEGORY_SCHEME_URN_NAMESPACE
  },
  {
    type: "conceptscheme",
    url: getConceptSchemeUrl(),
    urnNamespace: SDMX_JSON_CONCEPT_SCEHME_URN_NAMESPACE
  },
  {
    type: "dataflow",
    url: getDataflowUrl(),
    urnNamespace: SDMX_JSON_DATAFLOW_URN_NAMESPACE
  },
  {
    type: "metadataflow",
    url: getMetadataflowUrl(),
    urnNamespace: SDMX_JSON_METADATAFLOW_URN_NAMESPACE
  }
];

const AUTO_ANNOTATIONS = [
  "metadatasetid",
  "metadataflowcategorylist",
  "metadataflowid",
  "metadataflowagency",
  "metadataflowversion",
  "msdid",
  "msdagency",
  "msdversion"
];

export const customIsReferenceMetadataAutoAnnotation = annotation =>
  annotation.id && AUTO_ANNOTATIONS.includes(annotation.id.toLowerCase());

export const getWorkingAnnotations = metadataSet => {
  const metadataflowTriplet = metadataSet.metadataflowTriplet;
  const msdTriplet = getArtefactTripletFromUrn(metadataSet.msdUrn);

  return [
    {
      id: "MetadataflowId",
      text: {
        en: metadataflowTriplet.id
      }
    },
    {
      id: "MetadataflowAgency",
      text: {
        en: metadataflowTriplet.agencyID
      }
    },
    {
      id: "MetadataflowVersion",
      text: {
        en: metadataflowTriplet.version
      }
    },
    {
      id: "MSDId",
      text: {
        en: msdTriplet.id
      }
    },
    {
      id: "MSDAgency",
      text: {
        en: msdTriplet.agencyID
      }
    },
    {
      id: "MSDVersion",
      text: {
        en: msdTriplet.version
      }
    }
  ]
};

export const EXPORT_REPORT_FORMAT_XML = "xml";
export const EXPORT_REPORT_FORMAT_JSON = "json";

export const CATALOG_REPORT_ALREADY_PRESENT = "CATALOG_REPORT_ALREADY_PRESENT";
export const METADATAFLOW_OWNERSHIP_MISSING = "METADATAFLOW_OWNERSHIP_MISSING";
export const DATAFLOW_OWNERSHIP_MISSING = "DATAFLOW_OWNERSHIP_MISSING";
export const AGENCY_PERMISSION_MISSING = "AGENCY_PERMISSION_MISSING";

export const getImportReportResultTranslation = (errorCode, t) => {
  if (!errorCode) {
    return "";
  }

  if (!t) {
    return errorCode;
  }

  const errorCodes = {
    [CATALOG_REPORT_ALREADY_PRESENT]: t("scenes.referenceMetadata.commons.reportImportErrors.catalogAlreadyPresent"),
    [METADATAFLOW_OWNERSHIP_MISSING]: t("scenes.referenceMetadata.commons.reportImportErrors.metadataflowOwnershipMissing"),
    [DATAFLOW_OWNERSHIP_MISSING]: t("scenes.referenceMetadata.commons.reportImportErrors.dataflowOwnershipMissing"),
    [AGENCY_PERMISSION_MISSING]: t("scenes.referenceMetadata.commons.reportImportErrors.agencyPermissionMissing"),
    REPORT_IMPORTED: t("scenes.referenceMetadata.commons.reportImportErrors.importSuccess"),
    ERROR_IMPORT_REPORT: t("scenes.referenceMetadata.commons.reportImportErrors.importError"),
    ALREADY_IN_REPO: t("scenes.referenceMetadata.commons.reportImportErrors.idAlreadyUsed")
  };

  return errorCodes[errorCode] || errorCodes["ERROR_IMPORT_REPORT"];
};